import cx from 'clsx'
import React from 'react'
import Icon from 'src/components/icons/icon'

export type AlertProps = {
  kind?: 'warning' | 'danger' | 'info' | 'success'
  className?: string
  title?: string
  children?: React.ReactNode
} & React.HTMLAttributes<HTMLDivElement>

export default function Alert({ kind, className, title, children, ...rest }: AlertProps) {
  const alertClasses = 'px-4 py-3 rounded-md border text-sm'

  const alertColors = () => {
    switch (kind) {
      case 'success':
        return 'bg-green-100 border-green-200 text-green-700'
      case 'danger':
        return 'bg-red-100 border-red-200 text-red-700'
      case 'info':
        return 'bg-sky-100 border-sky-200 text-sky-700'
      default:
        return 'bg-amber-100 border-amber-200 text-amber-700'
    }
  }

  const getKindIcon = () => {
    switch (kind) {
      case 'success':
        return 'check-circle'
      case 'danger':
        return 'error'
      case 'info':
        return 'information'
      default:
        return 'lucide-alert'
    }
  }

  return (
    <div className={cx(alertClasses, alertColors(), className)} {...rest}>
      {title && (
        <div className='mb-2 flex items-center gap-2 font-bold'>
          <Icon name={getKindIcon()} size='16px' />
          {title}
        </div>
      )}
      <div>{children}</div>
    </div>
  )
}

Alert.displayName = 'Alert'
